import React from 'react';
import Loader, { LoaderProps } from './Loader';

type Props = LoaderProps & {
	children: React.ReactNode;
	fallback?: React.ReactNode;
};

export default function LazyWrap({ children, fallback, ...props }: Props) {
	return <React.Suspense fallback={fallback ?? <Loader {...props} />}>{children}</React.Suspense>;
}
